import Cookies from 'js-cookie';

export const getLang = () => {
  if (Cookies.get('lang')) return Cookies.get('lang');
  return navigator.language?.startsWith?.('en') ? 'en' : 'zh-TW';
};

export const switchLang = (lang?: string): string => {
  if (lang) {
    Cookies.set('lang', lang);
    return lang;
  }
  const currentLang = getLang();
  const newLang = currentLang === 'zh-TW' ? 'en' : 'zh-TW';
  Cookies.set('lang', newLang);
  return newLang;
};
